import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MileCalculatorService } from "../../../shared/services/mile-calc.service";
import { ListGeoPostalCodesByCityPath } from '@xpo-ltl-2.0/sdk-geolocation';
import { FormControlNameEnum } from "../../../shared/enums/form-control.enum";
import { CountryCd } from "@xpo-ltl/sdk-common";

@Component({
  selector: 'app-state-city',
  templateUrl: './state-city.component.html',
  styleUrls: ['./state-city.component.scss'],
})
export class StateCityComponent {
  formGroup: FormGroup;
  validStateCity: boolean;
  checking: boolean;

  postalCodes: string[];
  states: string[];

  country: CountryCd;

  @Input() set countryCd(country: CountryCd) {
    this.loadStates(country);
  }

  @Output() onSelectZipCode: EventEmitter<string>;

  constructor(private mileCalculatorService: MileCalculatorService) {
    this.postalCodes = [];
    this.states = [];
    this.onSelectZipCode = new EventEmitter<string>();

    this.formGroup = new FormGroup({
      state: new FormControl('', Validators.required),
      city: new FormControl('', Validators.required),
      zipCd: new FormControl('', Validators.required),
    });

    this.formGroup.get(FormControlNameEnum.ZIP_CD).valueChanges.subscribe((value) => this.onSelectZipCode.emit(value));
    this.formGroup.get(FormControlNameEnum.ZIP_CD).disable();
  }

  listZipCds(): void {
    this.checking = true;
    this.formGroup.get(FormControlNameEnum.STATE).setErrors(null);
    this.formGroup.get(FormControlNameEnum.CITY).setErrors(null);
    const params = new ListGeoPostalCodesByCityPath();
    params.countryCd = this.country;
    params.stateCd = this.formGroup.get(FormControlNameEnum.STATE).value?.toUpperCase();
    params.cityName = this.formGroup.get(FormControlNameEnum.CITY).value?.toUpperCase();

    this.mileCalculatorService.listGeoPostalCodesByCity(params).subscribe({
      next: (locations) => {
        this.postalCodes = locations;
        this.validStateCity = !!this.postalCodes.length;

        if (this.postalCodes.length === 1) {
          this.formGroup.get(FormControlNameEnum.ZIP_CD).patchValue(this.postalCodes[0]);
          this.formGroup.get(FormControlNameEnum.ZIP_CD).disable();
          this.formGroup.get(FormControlNameEnum.CITY).disable();
          this.formGroup.get(FormControlNameEnum.STATE).disable();
        } else if (this.postalCodes.length > 1) {
          this.formGroup.get(FormControlNameEnum.ZIP_CD).enable();
          this.formGroup.get(FormControlNameEnum.CITY).disable();
          this.formGroup.get(FormControlNameEnum.STATE).disable();
        } else {
          this.formGroup.get(FormControlNameEnum.STATE).setErrors({
            notFound: true,
          });
          this.formGroup.get(FormControlNameEnum.CITY).setErrors({
            notFound: true,
          });
        }
        this.checking = false;
      },
      error: (err) => {
        console.error(err);
        this.formGroup.get(FormControlNameEnum.STATE).setErrors({
          notFound: true,
        });
        this.formGroup.get(FormControlNameEnum.CITY).setErrors({
          notFound: true,
        });
        this.checking = false;
      },
    });
  }

  private loadStates(countryCd: CountryCd): void {
    this.country = countryCd;
    this.mileCalculatorService.listGeoStatesByCountryCd(countryCd).subscribe({
      next: (states) => {
        this.states = states;
      },
      error: (err) => {
        console.log(err);
      },
    });
  }
}
